class GiftingGiftFinder extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-gf-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-gf-panel]'));

    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('change', this.handleChange.bind(this));

    this.panels.forEach((panel) => this.updatePanel(panel));
  }

  handleClick(event) {
    const tab = event.target.closest('[data-gf-tab]');
    if (!tab) return;
    this.activateTab(tab);
  }

  handleChange(event) {
    if (event.target.type !== 'checkbox') return;
    const panel = event.target.closest('[data-gf-panel]');
    if (!panel) return;
    this.updatePanel(panel);
  }

  activateTab(tab) {
    const targetId = tab.getAttribute('aria-controls');

    this.tabs.forEach((otherTab) => {
      const isActive = otherTab === tab;
      otherTab.setAttribute('aria-selected', String(isActive));
      otherTab.classList.toggle('gifting-gift-finder__tab--active', isActive);
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== targetId;
    });
  }

  updatePanel(panel) {
    const filterType = panel.dataset.filterType;
    const items = Array.from(panel.querySelectorAll('[data-gf-item]'));
    const grid = panel.querySelector('[data-gf-grid]');
    const emptyMessage = panel.querySelector('[data-gf-empty]');
    const selectPrompt = panel.querySelector('[data-gf-select-prompt]');
    const limit = parseInt(grid ? grid.dataset.limit : '', 10) || items.length;

    let matched = items;
    let noSelection = false;

    if (filterType === 'collections') {
      const checked = Array.from(panel.querySelectorAll('input[data-gf-collection-filter]:checked')).map(
        (input) => input.dataset.gfCollectionFilter
      );
      noSelection = checked.length === 0;

      matched = noSelection
        ? []
        : items.filter((item) => {
            const collections = (item.dataset.collections || '').split(' ').filter(Boolean);
            return checked.some((value) => collections.includes(value));
          });
    } else if (filterType === 'price') {
      const checkedRanges = Array.from(panel.querySelectorAll('input[data-gf-price-min]:checked')).map((input) => ({
        min: Number(input.dataset.gfPriceMin),
        max: input.dataset.gfPriceMax === '' ? Infinity : Number(input.dataset.gfPriceMax),
      }));

      if (checkedRanges.length > 0) {
        matched = items.filter((item) => {
          const price = Number(item.dataset.price);
          return checkedRanges.some((range) => price >= range.min && price <= range.max);
        });
      }
    }

    const visible = new Set(matched.slice(0, limit));

    items.forEach((item) => {
      item.hidden = !visible.has(item);
    });

    if (emptyMessage) {
      emptyMessage.hidden = noSelection || matched.length !== 0;
    }

    if (selectPrompt) {
      selectPrompt.hidden = !noSelection;
    }
  }
}

if (!customElements.get('gifting-gift-finder')) {
  customElements.define('gifting-gift-finder', GiftingGiftFinder);
}
